// removed by extract-text-webpack-plugin
module.exports = {"panel":"src-components-project-panel----styles-module---panel---1BhE2","inner":"src-components-project-panel----styles-module---inner---35EA5","content":"src-components-project-panel----styles-module---content---dzr4U","mochashot":"src-components-project-panel----styles-module---mochashot---2aMHl","tictactoe":"src-components-project-panel----styles-module---tictactoe---3wJQ1","sheep":"src-components-project-panel----styles-module---sheep---2qYCy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/panel/styles.module.css
// module id = ./src/components/project/panel/styles.module.css
// module chunks = 102538987983895